import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Card, Container, Typography } from '@mui/material';
import Scrollbar from '../components/scrollbar/Scrollbar';
import ImportWarehousePackagesPanel from '../sections/@dashboard/importwarehouse/ImportWarehousePackagesPanel';
import { useGeneral } from '../context/general';

export default function ImportWarehousePackagesPage() {
  const { value } = useGeneral();
  const { userRolef, loggedIn, importWarehousePackages } = value;
  const navigate = useNavigate();

  useEffect(() => {
    if (!loggedIn || (userRolef !== 'Admin' && userRolef !== 'Staff')) {
      navigate('/Home');
    }
  }, [loggedIn, userRolef, navigate]);

  return (
    <>
      <Helmet>
        <title> Import Warehouse Packages | Snip &amp; Ship </title>
      </Helmet>

      <Container>
        <Typography variant="h4" gutterBottom>
          Import Warehouse Packages
        </Typography>

        <Card>
          <Scrollbar>
            <ImportWarehousePackagesPanel importWarehousePackages={importWarehousePackages} />
          </Scrollbar>
        </Card>
      </Container>
    </>
  );
}
